import colors from '../../colors';
import * as React from 'react';
import styled from 'styled-components';

interface Props {
    children: any;
    className?: string;
    color?: string;
}

const Title: React.SFC<Props> = ({ children, className, color }) => (
    <Wrapper className={className} color={color}>{children}</Wrapper>
);

export default Title;

const Wrapper = styled.h1`
    text-align: left;
    padding-left: 20px;
    flex-grow: 1;
    color: ${props => (props.color ? `${props.color} !important` : 'inherit')};
`;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Conversation/Cars/Title.tsx